import type { Difficulty } from "@hunch/core";

/** Per-round (or per-duel) countdown, shared by all three games and their
    start screens — null means no timer. */
export const ROUND_TIME_SECONDS: Record<Difficulty, number | null> = {
  easy: null,
  normal: 60,
  hard: 30,
};
